'use client';

import { useRouter } from 'next/navigation';
import { FC, useEffect, useState } from 'react';

import Portal from '@/components/core/Portal';
import useLocalStorage from '@/hooks/useLocalStorage';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

const DisclaimerModal: FC = () => {
  const router = useRouter();
  const [mounted, setMounted] = useState(false);
  const [ageConfirmedData, setAgeConfirmedData] = useLocalStorage('ageConfirmed', {
    value: false,
    expiration: 0,
  });

  const { t } = useTranslation();

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleConfirm = () => {
    const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    setAgeConfirmedData({ value: true, expiration: expirationTime });
  };

  const handleDeny = () => {
    window.history.back()
    const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    setAgeConfirmedData({ value: false, expiration: expirationTime });
  };

  useEffect(() => {
    const now = new Date().getTime();
    if (ageConfirmedData.expiration && now > ageConfirmedData.expiration) {
      setAgeConfirmedData({ value: false, expiration: 0 });
    }

    if (!ageConfirmedData.value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [ageConfirmedData, setAgeConfirmedData]);

  if (!mounted || ageConfirmedData.value) return null;

  return (
    <Portal id="modal-container">
      <div className="popupWrp">
        <div className="popupInner disclaimer">
          <div className="disclaimer-popup-content">
            {/* <div className="close-disclaimer-popup-block">
              <i className="bc-i-close close-disclaimer-icon" />
            </div> */}
            <div className="disclaimer-popup-info">
              <p className="disclaimer-popup-title">{t('popok18Years')}</p>
              <p className="disclaimer-popup-desc">{t('confirmText')}</p>
            </div>
            <div className="disclaimer-pop-btn-wrp">
              <button onClick={handleConfirm} className="button btnTypeBig fullWidth btnTypeGreen">
                <p>{t('18_PLUS_OK_TEXT')}</p>
              </button>
              <button
                onClick={handleDeny}
                className="button btnTypeBig fullWidth btnTypeTransparent"
              >
                <p> {t('confirmNo-No-take-me-back')} </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default DisclaimerModal;
